import { render } from "./SmartCardLink.vue?vue&type=template&id=5c304c7c&scoped=true"
import script from "./SmartCardLink.vue?vue&type=script&lang=js"
export * from "./SmartCardLink.vue?vue&type=script&lang=js"

import "./SmartCardLink.vue?vue&type=style&index=0&id=5c304c7c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c304c7c"

export default script